<template>
  <div>
    <v-alert type="info" dense text>
      A live preview of this (unsaved) report against the real data - exactly what people will see. Exports and prints are available once it is saved and opened from the Reports Hub.
    </v-alert>
    <v-card outlined class="mb-3">
      <v-card-text>
        <div class="d-flex align-center flex-wrap mb-2">
          <span class="text-body-2 mr-3">Showing:</span>
          <v-btn-toggle v-model="view" mandatory dense>
            <v-btn small value="main">Report page</v-btn>
            <v-btn v-for="d in tpl.drilldowns" :key="d.id" small :value="d.id">{{ d.name || d.id }}</v-btn>
          </v-btn-toggle>
        </div>
        <rb-filters v-if="tpl.params.length" v-model="state.previewParams" :params="tpl.params" :options="state.paramOptions" :loading="running" @run="run" />
        <v-btn v-else color="primary" :loading="running" @click="run"><v-icon left>mdi-play</v-icon>Run</v-btn>
      </v-card-text>
    </v-card>

    <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
    <div v-if="result && result.info && result.info.length" class="mb-3 d-flex flex-wrap align-center">
      <span class="text-caption grey--text mr-3">Calculated with:</span>
      <v-chip v-for="(i, k) in result.info" :key="k" small outlined class="mr-2 mb-1">{{ i.label }}: <b class="ml-1">{{ fmt(i.value, i.format) }}</b></v-chip>
    </div>
    <rb-report-renderer v-if="result" :template="renderTemplate" :result="result" :drill="view === 'main' ? null : view" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import RbFilters, { defaultValues } from '../RbFilters.vue'
import RbReportRenderer from '../RbReportRenderer.vue'
import { errorText, formatValue } from '../rbUtil'
import { state, refreshParamOptions } from './editorState'

export default {
  name: 'RbPreviewTab',
  components: { RbFilters, RbReportRenderer },
  data () {
    return { state, view: 'main', running: false, result: null, error: '', renderTemplate: null }
  },
  computed: {
    ...mapGetters(['getEndpoint']),
    tpl () { return state.tpl }
  },
  watch: {
    view () { this.result = null; this.error = ''; this.run() }
  },
  async mounted () {
    state.previewParams = { ...defaultValues(this.tpl.params), ...state.previewParams }
    await refreshParamOptions(this.getEndpoint)
    this.run()
  },
  methods: {
    fmt: formatValue,
    async run () {
      this.running = true
      this.error = ''
      try {
        const res = await axios.post(`${this.getEndpoint}/api/rb-builder/run-draft`, {
          template: this.tpl, params: state.previewParams, drill: this.view === 'main' ? undefined : this.view
        })
        this.renderTemplate = JSON.parse(JSON.stringify(this.tpl))
        this.result = res.data.data
      } catch (e) {
        this.result = null
        this.error = errorText(e)
      } finally {
        this.running = false
      }
    }
  }
}
</script>
